import { rgba } from 'utils/colors'

const customStyles = (additionalStyle) => {
  const styles = typeof additionalStyle === 'object' ? additionalStyle : { padding: 0, margin: 0 }

  return {
    overlay: {
      background: rgba('#000000', 0.7),
      zIndex: 3000
    },
    content: {
      width: 'auto',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      background: '#fff',
      boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.05)',
      borderRadius: '10px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: '100%',
      maxWidth: '90%',
      ...styles
    }
  }
}

export default customStyles
